export default "assets/images/icons/arrow-property-983b73d2.svg";